module.exports = __webpack_public_path__ + "media/images/icon-sales-disabled-4c839bcf1fa93a62dfbc7718f77965cc.svg";